












import Vue from 'vue'
import TopbTable from './components/TopbTable.vue'
import BottomTable from './components/BottomTable.vue'
export default Vue.extend({
  components: {
    TopbTable,
    BottomTable
  },
  data() {
    return {
      source: 0,
      bot: 0,
      editData: {}
    }
  },
  methods: {
    changeSelect(value) {
      this.editData = value
    },
    changeBot() {
      this.bot += 1
    },
    changeY() {
      setTimeout(() => {
        this.source += 1
      }, 50)
    }
  }
})
